import axios from "axios"
import { safeLocalStorage } from "../utils"

const API_BASE_PROD_URL = "https://v1.teache.co/api/" // live Server
const API_BASE_DEV_URL = "https://v1-dev.teache.co/api/" // develop Server

// REACT_APP_API_BASE_URL overrides the API for local/staging testing.
// When unset, production is used exactly as before.
const baseUrl = process.env.REACT_APP_API_BASE_URL || API_BASE_PROD_URL
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})

api.interceptors.request.use(
  (config) => {
    const storedToken = safeLocalStorage.getItem("token", null)
    if (storedToken) {
      config.headers["Authorization"] = `Bearer ${storedToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.error === "Unauthorized"
    ) {
      safeLocalStorage.removeItem("token")
      safeLocalStorage.removeItem("user")
      // window.location.href = "/";
      // useToast("error", "Invalid token")
    }
    return Promise.reject(error)
  }
)

const apiFormData = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
})

apiFormData.interceptors.request.use(
  (config) => {
    const storedToken = safeLocalStorage.getItem("token", null)
    if (storedToken) {
      config.headers["Authorization"] = `Bearer ${storedToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiFormData.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.error === "Unauthorized"
    ) {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      window.location.href = "/"
      // useToast("error", "Invalid token")
    }
    return Promise.reject(error)
  }
)

export { api, apiFormData, baseUrl }

